// @ts-check
import React from "react";

import { useNavigate } from "react-router";

import "./SideBar.scss";
import {
  Calendar,
  Filter,
  ImageUp,
  LogOut,
  RefreshCw,
  Server,
  ServerOff,
  Settings,
} from "lucide-react";

import { useMainContext } from "../MainContext";

/**
 * @returns {JSX.Element}
 */
function SideBar() {
  const navigate = useNavigate();
  const maincontext = useMainContext();
  
  const goToImageUploader = () => {
    navigate("/imgupload");
  };
  return (
    <div id="SideBar" className="Bg-primario">
      <AccionDrawer componente={0}>
        <Calendar size={30} color="white" />
      </AccionDrawer>
      <AccionDrawer componente={1}>
        <Filter size={30} color="white" />
      </AccionDrawer>
      <AccionDrawer componente={2}>
        <Settings size={30} color="white" />
      </AccionDrawer>
      <AccionDrawer onClick={goToImageUploader} componente={3}>
        <ImageUp size={30} color="white" />
      </AccionDrawer>
      <div style={{ flex: 1 }}></div>
      {maincontext.state.estudios.error ? (
        <AccionSistema>
          <ServerOff size={30} color="white" />
        </AccionSistema>
      ) : (
        <AccionSistema>
          <Server size={30} color="white" />
        </AccionSistema>
      )}
      <AccionSistema onClick={maincontext.syncLista} girar={maincontext.state.estudios.sync || maincontext.state.estudios.silentSync}>
        <RefreshCw size={30} color="white" />
      </AccionSistema>
      <AccionSistema>
        <LogOut size={30} color="white" />
      </AccionSistema>
    </div>
  );
}

export default SideBar;

/**
 * @typedef {Object} AccionDrawerProps
 * @property {number} [componente]
 * @property {() => void} [onClick]
 * @property {React.ReactNode} children
 */

/**
 * @param {AccionDrawerProps} props
 * @returns {JSX.Element}
 */
export const AccionDrawer = (props) => {
  const { state, dispatch } = useMainContext();
  let componente = props.componente ?? null;
  let clase =
    state.ui.drawer.componente === componente
      ? "AccionDrawer2 activo"
      : "AccionDrawer2";
  
  let click = () => {
    if (props.onClick) {
      props.onClick();
      return;
    }
    
    if (
      state.ui.drawer.visible === true &&
      state.ui.drawer.componente === componente
    ) {
      dispatch({ type: 'SET_DRAWER', payload: { visible: false, componente: null } });
    } else {
      dispatch({ type: 'SET_DRAWER', payload: { visible: true, componente: componente } });
    }
  };
  return (
    <div onClick={click} className="AccionDrawer">
      <div className="AccionDrawer1">{props.children}</div>
      <div className={clase}></div>
    </div>
  );
};

/**
 *
 * @param {object} props
 * @param {boolean} [props.girar]
 * @param {()=>void} [props.onClick]
 * @param {React.ReactNode} props.children
 * @returns {JSX.Element}
 */
export const AccionSistema = (props) => {
  let clase = props.girar ? "AccionSistema girar" : "AccionSistema";
  return (
    <div className={clase} onClick={props.onClick}>
      <div className="AccionSistema1">{props.children}</div>
    </div>
  );
};
